import React, { useMemo } from 'react';
import { styled } from '../../../libs/styled.es.js';

const Wrapper = styled.div `
  display: flex;
`;
const sizeMaps = {
    sm: '24px',
    md: '45px',
    lg: '55px',
};
const fontSizeMaps = {
    sm: '12px',
    md: '20px',
    lg: '24px',
};
const Segment = styled.div(({ size }) => `
  width: ${sizeMaps[size]};
  height: ${sizeMaps[size]};
  border-radius: 4px;
  background-image: linear-gradient(to bottom, #4a4a4a, #232222);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${fontSizeMaps[size]};
  font-weight: 700;
  overflow: hidden;
`);
const NumberFrame = styled.div `
  height: 45px;
  display: flex;
  align-items: center;
`;
const spacerSizeMap = {
    sm: '0.2rem',
    md: '0.5rem',
    lg: '0.8rem',
};
const Spacer = styled.div(({ size }) => `
  width: ${spacerSizeMap[size]};
`);
const extractParts = (number) => {
    const out = number.toString().padStart(2, '0');
    return [Number(out[0]), Number(out[1])];
};
const DefaultCountdown = ({ duration, size }) => {
    const [sec1, sec2] = useMemo(() => extractParts(duration.seconds), [duration.seconds]);
    const [min1, min2] = useMemo(() => extractParts(duration.minutes), [duration.minutes]);
    const [hour1, hour2] = useMemo(() => extractParts(duration.hours), [duration.hours]);
    return (React.createElement(Wrapper, null,
        React.createElement(Segment, { size: size },
            React.createElement(NumberFrame, null, hour1),
            React.createElement(NumberFrame, null, hour2)),
        React.createElement(Spacer, { size: size }),
        React.createElement(Segment, { size: size },
            React.createElement(NumberFrame, null, min1),
            React.createElement(NumberFrame, null, min2)),
        React.createElement(Spacer, { size: size }),
        React.createElement(Segment, { size: size },
            React.createElement(NumberFrame, null, sec1),
            React.createElement(NumberFrame, null, sec2))));
};

export { DefaultCountdown };
